import { motion } from "framer-motion";
import { EASE } from "./Reveal";

export const Page = ({ children, testId }) => (
  <motion.main
    data-testid={testId}
    initial={{ opacity: 0, y: 12 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, transition: { duration: 0.3 } }}
    transition={{ duration: 0.55, ease: EASE }}
  >
    {children}
  </motion.main>
);
